module.exports = __webpack_public_path__ + "img/right-nav-four.77279462.png";